/** Brand defaults for top-bar social icon color pickers. */
export type TopBarSocialPlatform = 'facebook' | 'x' | 'whatsapp';

export const TOP_BAR_SOCIAL_BRAND_COLORS: Record<TopBarSocialPlatform, string> = {
  facebook: '#1877f2',
  x: '#000000',
  whatsapp: '#25d366',
};

export function normalizeTopBarSocialIconColor(value: unknown): string {
  if (typeof value !== 'string') return '';
  const hex = value.trim();
  if (!hex) return '';
  if (/^#([0-9a-fA-F]{3})$/.test(hex)) {
    return `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`.toLowerCase();
  }
  if (/^#([0-9a-fA-F]{6})$/.test(hex)) {
    return hex.toLowerCase();
  }
  return '';
}

/** Value for `<input type="color">` (never empty). */
export function topBarSocialIconColorForPicker(
  stored: unknown,
  platform: TopBarSocialPlatform,
): string {
  return normalizeTopBarSocialIconColor(stored) || TOP_BAR_SOCIAL_BRAND_COLORS[platform];
}

/** Inline `color` when a custom hex is saved; otherwise theme CSS applies. */
export function resolveTopBarSocialIconColor(stored: unknown): string | undefined {
  const color = normalizeTopBarSocialIconColor(stored);
  return color || undefined;
}
